import {NotFoundComponent} from './features/miscelaneous/not-found/not-found.component';
import {Routes} from '@angular/router';
import {LayoutComponent} from './features/layout/layout/layout.component';
import {AuthGuard} from './features/auth/guards/auth.guard';
import {PermissionGuard} from './features/access/guards/permission.guard';
import {NotAuthGuard} from './features/auth/guards/not-auth.guart';
import {ForbiddenComponent} from './features/miscelaneous/forbidden/forbidden.component';
import {forwarderGuard} from './common/guards/forwarder.guard';
import {ListChecklistHeaderComponent} from './features/checklist-header/pages/list/list.component';
import {ListChecklistComponent} from './features/checklist-header/pages/items/items.component';
import {PrivacyPolicyComponent} from './features/miscelaneous/policy-privacy/policy-privacy.component';
import {CompaniesCompaniesComponent} from './features/checklist-header/pages/companies/companies.component';
import {DashboardComponent} from "@/features/dashboard/pages/dashboard/dashboard.component";
import { ListMaintenanceComponent } from './features/maintenance-header/pages/list/list.component';
import { VehicleRevisionListComponent } from './features/vehicle-revision/pages/list/list.component';
import { VehicleRevisionDetailComponent } from './features/vehicle-revision/pages/detail/detail.component';
import { VehicleTrackerMapComponent } from './features/vehicle-tracker/pages/map/map.component';
import { VehicleTrackerDetailComponent } from './features/vehicle-tracker/pages/detail/detail.component';
import { FleetListComponent } from './features/fleet/pages/list/list.component';

export const appRoutes: Routes = [
  {
    path: 'home',
    canActivate: [forwarderGuard],
    component: NotFoundComponent,
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Início',
      breadcrumbIcon: 'home',
      title: 'Início',
    },

    children: [
      {
        path: '',
        component: CompaniesCompaniesComponent,
      },
      {
        path: 'company/:id/checklist-headers',
        component: ListChecklistHeaderComponent,
      },
      {
        path: 'checklist-headers/:id',
        component: ListChecklistComponent,
      },
      {
        path: 'dashboard',
        component: DashboardComponent
      },
      {
        path: 'maintenance',
        component: ListMaintenanceComponent
      },
      {
        path: 'revisions',
        component: VehicleRevisionListComponent,
        canActivate: [PermissionGuard],
        data: {
          breadcrumb: 'Revisões',
          breadcrumbIcon: 'car_repair',
          title: 'Revisões',
          permission: 'ADMIN',
        },
      },
      {
        path: 'revisions/:chassis',
        component: VehicleRevisionDetailComponent,
        canActivate: [PermissionGuard],
        data: {
          breadcrumb: 'Detalhe',
          title: 'Revisão',
          permission: 'ADMIN',
        },
      },
      {
        path: 'fleet',
        component: FleetListComponent,
        canActivate: [PermissionGuard],
        data: {
          breadcrumb: 'Ficha de veículos',
          breadcrumbIcon: 'directions_car',
          title: 'Ficha de veículos',
          permission: 'ADMIN',
        },
      },
      {
        path: 'tracker',
        component: VehicleTrackerMapComponent,
        canActivate: [PermissionGuard],
        data: {
          breadcrumb: 'Rastreador',
          breadcrumbIcon: 'my_location',
          title: 'Rastreador',
          permission: 'ADMIN',
        },
      },
      {
        path: 'tracker/:chassis',
        component: VehicleTrackerDetailComponent,
        canActivate: [PermissionGuard],
        data: {
          breadcrumb: 'Detalhe',
          title: 'Rastreador',
          permission: 'ADMIN',
        },
      },      {
        path: 'config',
        loadChildren: () => import('./features/config/config-routes'),
      },
    ],
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./features/auth/auth.module').then(
        ({AuthModule}) => AuthModule
      ),
  },

  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
  },

  {
    path: 'register',
    canActivate: [NotAuthGuard],
    loadChildren: () => import('./features/register/register-routes'),
  },
  {
    path: 'forbidden',
    component: ForbiddenComponent,
  },
  {
    path: '**',
    component: NotFoundComponent,
    pathMatch: 'full',
  },
];
